import { render, staticRenderFns } from "./ProductoLogisticaForm.vue?vue&type=template&id=40c6132b&"
import script from "./ProductoLogisticaForm.vue?vue&type=script&lang=js&"
export * from "./ProductoLogisticaForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductoLogisticaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports